export const SearchCriteriaLabels = {
    fnad: 'Finance',
    address: 'Address',
    phone: 'Any Phone',
    direct_phone: 'Any Direct Phone',
    any_mobile: 'Any Mobile Phone',
    personal_mobile: 'Personal Mobile',
    work_mobile: 'Work Mobile',
    personal_email: 'Personal Email',
    linkedin_url: 'Linkedin Url',
    job_title: 'Title',
    hr: 'HR',
    it_is: 'IT',
    lgl: 'Legal',
    mrkt: 'Marketing',
    ops: 'Operations',
    prc: 'Procurement',
    enrd: 'R&D',
    sale: 'Sales',
    other: 'Cross Functional',
    all: 'All',
    email: 'Email',
    humanverified: 'Human Verified',
    premium: 'Premium',
    advanced: 'Advanced',
    plus: 'Plus',
    standard: 'Standard',
    base: 'Base',
    marketing: 'Marketing',
    operations: 'Operations',
    procurement: 'Procurement',
    legal: 'Legal',
    rnd: 'R&D',
    it: 'IT',
    sales: 'Sales',
    finance: 'Finance'
};

export const SearchLevelLabels = {
    brd: 'Board Members',
    chf: 'C-level Executives',
    vp: 'Vice Presidents',
    dir: 'Directors',
    mgr: 'Managers',
    stf: 'Key Influencers',
    other: 'Other'
};
